import React, { Component } from 'react'

import classes from '../layout.css'
import { 
	ModuleOne, 
	ModuleTwo, 
	ModuleThree } from '../../../components/Modules'

class ThirdMolarExatraction extends Component {
	render() {
		const { addToForm, consentForm } = this.props

		return (
			<form id={consentForm.formId} className={classes.Container}>
				<h2>{consentForm.formName}</h2>

				<ModuleOne 
					consentForm={consentForm}
					addToForm={addToForm} 
				/>
				<ModuleThree content={"extraction of third molars"}/>
				<ModuleTwo 
					consentForm={consentForm}
					addToForm={addToForm} 
				/>
			</form>
		)
	}
}

export default ThirdMolarExatraction


// WEBPACK FOOTER //
// ./src/containers/FormLayout/Form/10.js